export default function VPNFeatures() {
  const features = [
    {
      icon: 'ri-shield-check-line',
      title: '256-bit Encryption',
      description: 'Military-grade AES-256 encryption protects your data from hackers and surveillance, ensuring complete privacy for all your online activities.',
      gradient: 'from-purple-600 to-purple-800',
      height: 'h-[400px]'
    },
    {
      icon: 'ri-global-line',
      title: 'Global Network',
      description: 'Connect to high-speed servers across multiple countries. Access content from anywhere with unlimited bandwidth and lightning-fast speeds.',
      gradient: 'from-cyan-600 to-cyan-800',
      height: 'h-[350px]'
    },
    {
      icon: 'ri-eye-off-line',
      title: 'Zero Logs Policy',
      description: 'We never track, collect, or share your private data. Your online activity remains completely anonymous and secure at all times.',
      gradient: 'from-blue-700 to-blue-900',
      height: 'h-[300px]'
    }
  ];

  return (
    <section id="features" className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <div className="inline-block mb-4 px-4 py-1.5 bg-cyan-100 rounded-full">
            <span className="text-cyan-600 text-xs font-semibold uppercase tracking-wider">Security First</span>
          </div>
          <h2 className="text-5xl md:text-6xl font-bold text-gray-900 mb-6">
            Military-Grade Protection
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Advanced encryption standards combined with cutting-edge technology to keep your data safe and your identity protected across all devices and networks.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {features.map((feature, index) => (
            <div
              key={index}
              className={`${feature.height} bg-gradient-to-br ${feature.gradient} rounded-3xl p-8 flex flex-col items-center justify-center text-center shadow-xl hover:shadow-2xl transition-all duration-300 hover:-translate-y-2 cursor-pointer group`}
            >
              <div className="w-20 h-20 flex items-center justify-center mb-6">
                <i className={`${feature.icon} text-7xl text-white group-hover:scale-110 transition-transform`}></i>
              </div>
              <h3 className="text-2xl font-bold text-white mb-4">{feature.title}</h3>
              <p className="text-white/90 leading-relaxed">{feature.description}</p>
            </div>
          ))}
        </div>

        <div className="mt-20 bg-white rounded-3xl p-12 shadow-lg">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
            <div>
              <div className="inline-block mb-4 px-4 py-1.5 bg-cyan-100 rounded-full">
                <span className="text-cyan-600 text-xs font-semibold uppercase tracking-wider">Advanced Technology</span>
              </div>
              <h3 className="text-4xl md:text-5xl font-bold text-gray-900 mb-8 leading-tight">
                Built for the Modern Internet
              </h3>
              <div className="space-y-5">
                <div className="flex items-start gap-4">
                  <i className="ri-checkbox-circle-fill text-cyan-500 text-2xl mt-1"></i>
                  <div>
                    <p className="text-lg text-gray-700 font-medium">Next-generation WireGuard protocol</p>
                    <p className="text-gray-600 text-sm mt-1">Faster speeds with enhanced security</p>
                  </div>
                </div>
                <div className="flex items-start gap-4">
                  <i className="ri-checkbox-circle-fill text-cyan-500 text-2xl mt-1"></i>
                  <div>
                    <p className="text-lg text-gray-700 font-medium">Automatic kill switch protection</p>
                    <p className="text-gray-600 text-sm mt-1">Prevents data leaks if connection drops</p>
                  </div>
                </div>
                <div className="flex items-start gap-4">
                  <i className="ri-checkbox-circle-fill text-cyan-500 text-2xl mt-1"></i>
                  <div>
                    <p className="text-lg text-gray-700 font-medium">DNS leak prevention</p>
                    <p className="text-gray-600 text-sm mt-1">Complete privacy for all your requests</p>
                  </div>
                </div>
              </div>
              <button className="mt-8 px-8 py-3 border-2 border-cyan-500 text-cyan-500 rounded-full font-semibold hover:bg-cyan-500 hover:text-white transition-all whitespace-nowrap cursor-pointer">
                Learn More About Our Technology
              </button>
            </div>
            <div className="relative">
              <div className="bg-gradient-to-br from-gray-800 to-gray-900 rounded-3xl p-8 shadow-2xl transform hover:scale-105 transition-transform">
                <img
                  src="https://public.readdy.ai/ai/img_res/8dbe45a3dd4f0648d4e350e29aec32e1.jpg"
                  alt="VPN Dashboard"
                  className="w-full h-full object-cover rounded-2xl"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
